import React, { useEffect } from 'react';
import {
  useSearchParams, useNavigate,
} from 'react-router-dom';
import * as UserAPI from '../../api/User';
import { useUserStore } from '../../hooks/zustand/user';
import { track, Events } from 'src/utils/analytics';

function GoogleRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const setUser = useUserStore((state) => state.setUser);
  const setUserError = useUserStore((state) => state.setUserError);

  const handleCredentialResponse = async () => {
    const data: any = {
      code: searchParams.get('code') || '',
    };

    // We send state through Google authentication from GoogleButton.tsx
    // and receive it here. It is a URL-encoded string in the form of
    // query parameters.
    const state = new URLSearchParams(searchParams.get('state') || '');
    const role = state.get('role') || 'individual';
    // Prefer `state` (survives the www↔non-www redirect); fall back to
    // localStorage only for the same-origin case.
    const flow = state.get('flow') || localStorage.getItem('registerFlow') || 'signIn';
    const joinCode = state.get('joinCode') || localStorage.getItem('joinCode') || undefined;

    try {
      if (flow === 'signUp') {
        data.join_code = joinCode;

        const response: any = await UserAPI.googleSignUp(data, ['teacher'].includes(role));
        if (response.status !== 200 && response.status !== 201) {
          throw response.data;
        }
        track(Events.Signup, { method: 'google', role });
        setUser(response.data.data);
        return;
      }

      const response: any = await UserAPI.googleSignIn({ code: data.code });
      if (response.status !== 200 && response.status !== 201) throw response.data;
      track(Events.Login, { method: 'google' });
      setUser(response.data.data);
    } catch (error: any) {
      localStorage.removeItem('joinCode');
      setUserError({ error: true, message: error?.response?.data?.message || '' });
      if (flow === 'signUp') {
        navigate(`/register-${role}`);
      } else {
        navigate('/login');
      }
    }
  };

  useEffect(() => {
    handleCredentialResponse();

    return () => {
      localStorage.removeItem('registerFlow');
    };
  }, []);

  return (
    <div />
  );
}

export default GoogleRedirect;
